import React from 'react';
import styled from 'styled-components';
import { string, number, object } from 'prop-types';
import Wrapper from '../Wrapper';
import { logo } from '../../utils/statics';

const AirAsiaLogo = styled.img`
  width: ${({ width }) => width || '24px'};
  height: ${({ height }) => height || '24px'};
  object-fit: unset;
  overflow: unset;
  margin-top: ${({ mt }) => mt || '8px'};
`;

const IconWrapper = styled.div`
  width: ${({ width }) => width || '24px'};
  height: ${({ height }) => height || '24px'};
  border: 1px solid #d9dbe0;
  /* Use ratio-based calculations */
  margin-left: ${({ width }) =>
    width ? parseInt(width, 10) * 0.33 + 'px' : '8px'};
  margin-top: ${({ height }) =>
    height ? -(parseInt(height, 10) * 1.58) + 'px' : '-38px'};
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`;

const FirstIcon = styled.img`
  width: ${({ width }) => width || '24px'};
  height: ${({ height }) => height || '24px'};
`;

const SecondIcon = styled.img`
  width: ${({ width }) => width || '24px'};
  height: ${({ height }) => height || '24px'};
`;

const LegSecondIcon = styled.div`
  width: ${({ width }) => width || '24px'};
  height: ${({ height }) => height || '24px'};
  border: 1px solid #d9dbe0;
  /* For second icon in 3-icon scenario: ratio ~ -1.4167 top, 0.17 left */
  margin-left: ${({ width }) =>
    width ? parseInt(width, 10) * 0.17 + 'px' : '4px'};
  margin-top: ${({ height }) =>
    height ? -(parseInt(height, 10) * 1.4167) + 'px' : '-34px'};
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`;

const LegThirdIcon = styled.div`
  width: ${({ width }) => width || '24px'};
  height: ${({ height }) => height || '24px'};
  border: 1px solid #d9dbe0;
  /* For third icon in 3-icon scenario: ratio ~ -1.25 top, 0.5 left */
  margin-left: ${({ width }) =>
    width ? parseInt(width, 10) * 0.5 + 'px' : '12px'};
  margin-top: ${({ height }) =>
    height ? -(parseInt(height, 10) * 1.25) + 'px' : '-30px'};
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`;

const IconOverlap = ({
  stop,
  carrierLogo,
  carrierLogo1,
  carrierLogo2,
  mt,
  iconProps,
}) => {
  if (stop === 1 && carrierLogo) {
    return (
      <AirAsiaLogo
        {...iconProps}
        mt={mt}
        className="aa-logo"
        src={carrierLogo}
      />
    );
  } else if (stop === 2 && carrierLogo && carrierLogo1) {
    return (
      <Wrapper mt={mt || '12px'}>
        <FirstIcon {...iconProps} className="first-icon" src={carrierLogo} />
        <IconWrapper {...iconProps} className="second-icon">
          <SecondIcon {...iconProps} src={carrierLogo1} />
        </IconWrapper>
      </Wrapper>
    );
  } else if (stop === 3 && carrierLogo && carrierLogo1 && carrierLogo2) {
    return (
      <Wrapper mt={mt || '12px'}>
        <FirstIcon {...iconProps} className="first-icon1" src={carrierLogo} />
        <LegSecondIcon {...iconProps} className="leg-second-icon">
          <SecondIcon {...iconProps} src={carrierLogo1} />
        </LegSecondIcon>
        <LegThirdIcon {...iconProps} className="leg-third-icon">
          <SecondIcon {...iconProps} src={carrierLogo2} />
        </LegThirdIcon>
      </Wrapper>
    );
  }
  return null;
};

IconOverlap.propTypes = {
  stop: number.isRequired,
  carrierLogo: string,
  carrierLogo1: string,
  carrierLogo2: string,
  mt: string,
  iconProps: object,
};

IconOverlap.defaultProps = {
  carrierLogo: '',
  carrierLogo1: '',
  carrierLogo2: '',
  iconProps: {},
};

export default React.memo(IconOverlap);
